import { Tooltip as RechartsTooltip } from 'recharts';

import { CustomCursor } from './CustomCursor';
import { TooltipContent } from './TooltipContent';
import { ChartTooltipProps } from './types';

export const ChartTooltip = <T, V = string | number>({
  header,
  footer,
  alwaysActive,
  defaultActiveIndex = undefined,
  sx,
  TooltipComponent,
  testId = 'chart-tooltip',
  formatValue,
  ...props
}: ChartTooltipProps<T, V>) => {
  return (
    <RechartsTooltip
      allowEscapeViewBox={{
        x: false,
        y: false,
      }}
      {...props}
      isAnimationActive={false}
      filterNull={false}
      offset={10}
      active={alwaysActive}
      defaultIndex={defaultActiveIndex}
      cursor={<CustomCursor />}
      content={
        TooltipComponent ? (
          <TooltipComponent />
        ) : (
          <TooltipContent<T, V>
            Header={header}
            Footer={footer}
            sx={sx}
            testId={testId}
            formatValue={formatValue}
          />
        )
      }
    />
  );
};
